import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import VenuesList from './VenuesList';
import PageContainer from '../../../shared/layout/containers/PageContainer';
import PageHeader from '../../../shared/layout/headers/PageHeader';
import PageTitle from '../../../shared/layout/titles/PageTitle';
import PageContent from '../../../shared/layout/containers/PageContent';
import { getIconForPath } from '../../../config/navigationConfig';

const Venues = () => {
    const { t } = useTranslation();
    const location = useLocation();

    const pageIcon = getIconForPath(location.pathname);

    return (
        <PageContainer>
            <PageHeader>
                <PageTitle icon={pageIcon}>{t('Venues.title')}</PageTitle>
            </PageHeader>

            <PageContent>
                <VenuesList />
            </PageContent>
        </PageContainer>
    );
};

export default Venues;
